export default "__VITE_ASSET__DVxqjnLF__"